import { render, staticRenderFns } from "./ydXjUpImg.vue?vue&type=template&id=cb2fb44a&scoped=true&"
import script from "./ydXjUpImg.vue?vue&type=script&lang=js&"
export * from "./ydXjUpImg.vue?vue&type=script&lang=js&"
import style0 from "./ydXjUpImg.vue?vue&type=style&index=0&id=cb2fb44a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb2fb44a",
  null
  
)

export default component.exports